import React from 'react';
import cx from 'classnames';
import styles from './index.module.scss.js';

const Sessions = ({
  className,
  style,
  table,
  loadMore,
  text = {
    currentSession: "Current Session"
  },
  animations = {
    "data-aos": "fade-up-sm",
    "data-aos-delay": "200",
    "data-aos-duration": "1000"
  },
  ...props
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    className: cx(styles.box, className),
    style,
    ...animations,
    ...props
  },
  /* @__PURE__ */ React.createElement("div", { className: cx(styles.title) }, text.currentSession),
  /* @__PURE__ */ React.createElement("div", { className: styles.table }, table),
  loadMore && /* @__PURE__ */ React.createElement("div", { className: styles["load-more"] }, loadMore)
);
Sessions.displayName = "Sessions";

export { Sessions };
//# sourceMappingURL=index.js.map
